import includes from 'lodash/includes'
import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import accessGroupMemberships from 'modules/dashboard/store/collections/AccessGroupMemberships'
import Group from 'modules/dashboard/store/models/communities/Group'

class Groups extends Collection<Group> {
  constructor(data: any = []) {
    super(data)
    makeObservable(this, {
      fromCurrentUser: computed,
    })
  }

  get cacheKey(): string {
    return 'groups'
  }

  model() {
    return Group
  }

  get fromCurrentUser(): Group[] {
    const accessGroupIds = accessGroupMemberships.map((model) => model.attributes.access_group_id)

    return this.models.filter((group) => includes(accessGroupIds, group.get('access_group_id')))
  }
}

export default new Groups()
